import { Routes } from '@angular/router';
import { ScenicPlayerPage } from './scenic-player-page';
import { CoachingPlayerPage } from './coaching-player-page';
import { ErrorPage } from './error-page';

export const routes: Routes = [
  {
    path: '',
    component: ErrorPage,
  },
  {
    path: ':hashId',
    component: ErrorPage,
  },
  {
    path: 'scenic/:scenicId',
    component: ScenicPlayerPage,
  },
  {
    path: 'coaching/:coachingId',
    component: CoachingPlayerPage,
  },
  {
    path: '**',
    component: ErrorPage,
  },
];
